<template>
    <v-dialog  v-model="dialog" scrollable max-height="auto" :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : '50%'" persistent >
        <v-card 
                outlined
                height="80vh"
                prominent
                class="mx-auto elevation-0 overflow-y-auto"
            >

            <v-card-title class="ma-0 pa-0">
                <v-app-bar dense height="45" class='mb-0 elevation-1'>
                        
                    <v-toolbar-title class="subtitle-1">
                            <span class="mb-0">
                                <span v-if="selectAllFiltered">({{ effectiveSelectedCount }}) Professores do filtro selecionados</span>
                                <span v-else>({{ selected.length }}) Professor(es) selecionado(s)</span>
                            </span>
                        </v-toolbar-title>

                        <v-spacer></v-spacer>

                          <emc-button-icon icon='mdi-refresh' text="Atualizar" color="success" :loading="loadingRefresh" :disabled="loadingSaving" @click.prevent.stop="getItems(true)" />

                        <v-tooltip v-if="totalPages > 1" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :disabled="(!selectAllFiltered && selected.length === 0)" icon @click.native="clearFilter()" v-bind="attrs" v-on="on">
                                    <v-icon color="primary lighten-2">mdi-playlist-remove</v-icon>
                                </v-btn>
                            </template>
                            <span>Limpar todos items selecionados</span>
                        </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click.native="dialog = false" v-bind="attrs" v-on="on">
                                <v-icon color="red lighten-2">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Fechar</span>
                    </v-tooltip>
                </v-app-bar>
            </v-card-title>
            
            <v-card-text  class="pt-2">
                <v-container>
                     <v-row class="mb-0">
                        <v-col cols="12" sm="6">
                             <sys-select-term
                                 :model.sync="term_id"
                                 label="Termo"
                                 dense
                                 outlined
                                 :disabled="loadingSaving"
                             />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <sys-select-company
                                 :model.sync="companyIds"
                                 label="Empresa"
                                 dense
                                 outlined
                                 clearable
                                 multiple
                                 :disabled="loadingSaving"
                             />
                        </v-col>
                    </v-row>
                    <v-row class="mb-0">
                        <v-col cols="12" sm="6">
                             <sys-select-campus
                                 :model.sync="campusIds"
                                 :educationalGroupId="educationalGroupId"
                                 label="Campus"
                                 dense
                                 outlined
                                 clearable
                                 multiple
                                 filter-relation="groups"
                                 :return-object="false"
                                 :disabled="loadingSaving"
                             />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <sys-select-course
                                 :model.sync="courseIds"
                                 :campusId="campusIdsForCourse"
                                 label="Curso"
                                 dense
                                 outlined
                                 clearable
                                 multiple
                                 :return-object="false"
                                 filter
                                 :disabled="loadingSaving"
                             />
                        </v-col>
                    </v-row>
                    <v-row class="mb-0">
                        <v-col cols="12" sm="6">
                             <SelectVariationStatus
                                 v-model="workLoadVariationStatus"
                                 label="Status de Variação"
                                 outlined
                                 dense
                                 load-data
                                 clearable
                                 :disabled="loadingSaving"
                             />
                        </v-col>
                        <v-col cols="12" sm="6">
                             <sys-select-teacher-position
                                :model.sync="teacherPositionIds"
                                label="Cargo"
                                multiple
                                dense
                                outlined
                                clearable
                                select-all
                                filterRelation="contracts"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="12" sm="12" class="pt-0">
                             <v-text-field
                                 v-model="search"
                                 label="Buscar professor por nome"
                                 prepend-inner-icon="mdi-magnify"
                                 clearable
                                 dense
                                 outlined
                                 hide-details
                                 class="mb-2"
                                 :disabled="loadingSaving"
                                 @input="onSearchInput"
                             />
                            <v-list dense class="pa-0 ma-0">
                                    <v-list-item-group
                                        v-model="selectedTeacher"
                                        color="primary"
                                    >
                                            <v-list-item
                                                ripple
                                                @mousedown.prevent
                                                @click="toggle"
                                            >
                                                 <v-list-item-action>
                                                    <v-icon v-if="items.length" :color="(selectAllFiltered || selected.length > 0) ? 'indigo darken-4' : ''">
                                                         {{ icon }}
                                                     </v-icon>
                                                 </v-list-item-action>
                                             <v-list-item-content>
                                                 <v-list-item-title>
                                                        {{ selectAllLabel }}
                                                 </v-list-item-title>
                                             </v-list-item-content>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                
                                                 <v-progress-linear
                                                     v-if="loading"
                                                     indeterminate
                                                     color='yellow darken-2'
                                                 />

                                                <v-card v-if="loadingSaving" class="mt-2" outlined>
                                                    <v-card-text class="py-2">
                                                        <div class="d-flex align-center justify-space-between">
                                                            <div>
                                                                Gerando {{ generateProgress.processed }} de {{ generateProgress.total }}
                                                            </div>
                                                            <v-btn small text color="error" :disabled="cancelGenerate" @click.prevent.stop="cancelGenerate = true">
                                                                Cancelar
                                                            </v-btn>
                                                        </div>
                                                        <v-progress-linear
                                                            :value="generateProgressPercent"
                                                            height="10"
                                                            rounded
                                                            color="amber darken-1"
                                                        />
                                                    </v-card-text>
                                                </v-card>

                                                <emc-util-scroll height="40vh">
                                                     <v-list-item
                                                         v-for="(item, index) in items"
                                                         :key="index"
                                                         @mousedown.prevent
                                                         @click="selectTeacher(index)"
                                                         >
                                                        <v-list-item-icon>
                                                            <v-icon :color="isCheckedTeacher(index) ? 'indigo darken-4' : ''" v-text="isCheckedTeacher(index) ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'" />
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="item.name"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </emc-util-scroll>
                                    </v-list-item-group>
                                </v-list>
                        </v-col>
                    </v-row>
                    
                </v-container>
            </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row align="center" class="mb-2">
                            <v-col cols="12" sm="6" class="d-flex align-center">
                                <v-btn
                                    color="amber darken-1"
                                    :disabled="disableButton"
                                    :loading="loadingSaving"
                                    @click.prevent.stop="generate()"
                                    depressed
                                >
                                    <v-icon left>mdi-flash-outline</v-icon>
                                    Gerar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" class="d-flex justify-end">
                                     <v-pagination
                                     v-model="page"
                                     class="my-0"
                                     :disabled="loadingSaving"
                                     @input="pagination()"
                                     :length="totalPages"
                                     ></v-pagination>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-card-actions>
            
        </v-card>

        <v-dialog v-model="confirmDialog.show" max-width="520" persistent>
            <v-card outlined>
                <v-card-title class="subtitle-1">{{ confirmDialog.title }}</v-card-title>
                <v-card-text>{{ confirmDialog.text }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent.stop="resolveConfirm(false)">{{ confirmDialog.cancelLabel }}</v-btn>
                    <v-btn color="amber darken-1" depressed @click.prevent.stop="resolveConfirm(true)">{{ confirmDialog.confirmLabel }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">Fechar</v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import SelectVariationStatus from '@/domains/teacher/indicator/components/SelectVariationStatus.vue'

export default {
    name: "SysTermGenerate",
    data: (vm) => ({
        dialog: false,
        loading: false,
        loadingRefresh: false,
        loadingSaving: false,
        page: 1,
        maxSelected: 200,
        batchSize: 500,
        totalPages: 0,
        term_id: null,
        items: [],
        selected: [],
        selectedCurrent: [],
        excludedSelected: [],
        selectedTeacher: null,
        workLoadVariationStatus: null,
        teacherPositionIds: [],
        educationalGroupId: null,
        companyIds: [],
        campusIds: [],
        courseIds: [],
        search: '',
        searchTimeout: null,
        selectAllFiltered: false,
        filteredTotal: 0,
        cancelGenerate: false,
        generateProgress: {
            processed: 0,
            total: 0,
        },
        confirmDialog: {
            show: false,
            title: 'Confirmação',
            text: '',
            confirmLabel: 'Confirmar',
            cancelLabel: 'Cancelar',
            _resolve: null,
        },
        snackbar: {
            show: false,
            message: '',
            color: 'error',
            timeout: 6000,
        },
    }),
    components: {
        SelectVariationStatus,
    },
    computed: {
        ...mapState('auth', ['acesso', 'user']),
        
        campusIdsForCourse() {
            const ids = Array.isArray(this.campusIds) ? this.campusIds : [];
            return ids.map(c => (typeof c === 'object' && c != null && c.id != null) ? c.id : c).filter(Boolean);
        },

        disableButton (){

            if (!this.term_id) return true;
            if (this.loadingSaving) return true;
            if (this.selectAllFiltered) return this.effectiveSelectedCount === 0;
            return !this.selected.length;

        },

        effectiveSelectedCount() {
            if (!this.selectAllFiltered) return this.selected.length;
            return Math.max(0, (this.filteredTotal || 0) - this.excludedSelected.length);
        },

        likesAllTeacher () {

            if (this.selectAllFiltered) return this.items.length > 0 && this.selectedCurrent.length === this.items.length;
            return this.selectedCurrent.length === this.items.length
        },

        likesSomeTeacher () {
            if (this.selectAllFiltered) return false;
            return this.selectedCurrent.length > 0 && !this.likesAllTeacher
        },

        icon () {
            if (this.likesAllTeacher) return 'mdi-close-box'
            if (this.likesSomeTeacher) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },

        selectAllLabel() {
            if (this.selectAllFiltered) return 'Desmarcar todos';
            const total = this.filteredTotal || 0;
            return total > 0 ? `Selecionar todos do filtro (${total})` : 'Selecionar todos do filtro';
        },

        generateProgressPercent() {
            const total = Number(this.generateProgress?.total || 0);
            const processed = Number(this.generateProgress?.processed || 0);
            if (!total) return 0;
            return Math.min(100, Math.max(0, (processed / total) * 100));
        },

        confirmText() {
            // Mantem o modal simples sem dependencias extras
            return {
                selectAll: (total) => total > 0
                    ? `Selecionar TODOS os professores do filtro (${total} professores)?`
                    : 'Selecionar TODOS os professores do filtro?',
                generateAll: (total) => total > 0
                    ? `Voce selecionou ${total} professores do filtro. Isso pode levar alguns minutos. Deseja continuar?`
                    : 'Voce selecionou professores do filtro. Isso pode levar alguns minutos. Deseja continuar?',
            };
        },

    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    watch: {

        dialog(val) {
            this.$emit('update:show', val);
            if (!val) {
                this.cancelGenerate = true;
                this.resetModal();
            }
        },

        show(val) {
            this.dialog = val;
            if (val) {
                if (this.acesso && this.acesso.grupo && this.acesso.grupo.id) {
                    this.educationalGroupId = this.acesso.grupo.id;
                }
                if (this.items.length === 0) {
                    this.getItems();
                }
            } else {
                this.cancelGenerate = true;
            }
        },

        // Watchers para recarregar lista ao mudar filtros de segmentação (apenas quando modal aberto)
        educationalGroupId() {
            if (this.dialog) this.resetAndReload();
        },

        companyIds() {
            if (this.dialog) this.resetAndReload();
        },

        campusIds() {
            if (this.dialog) this.resetAndReload();
        },

        courseIds() {
            if (this.dialog) this.resetAndReload();
        },

        workLoadVariationStatus() {
            if (this.dialog) this.resetAndReload();
        },

        teacherPositionIds() {
            if (this.dialog) this.resetAndReload();
        },

    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeachers']),
        ...mapActions('term', ['ActionUpdateTermSignatureGenerate']),

        resetModal() {
            this.page = 1;
            this.term_id = null;
            this.items = [];
            this.selected = [];
            this.selectedCurrent = [];
            this.excludedSelected = [];
            this.selectedTeacher = null;
            this.workLoadVariationStatus = null;
            this.educationalGroupId = this.acesso?.grupo?.id || null;
            this.companyIds = [];
            this.campusIds = [];
            this.courseIds = [];
            this.search = '';
            this.totalPages = 0;
            this.loading = false;
            this.loadingRefresh = false;
            this.loadingSaving = false;
            this.selectAllFiltered = false;
            this.filteredTotal = 0;
            // Se houver geracao em andamento, interrompe o loop
            this.cancelGenerate = true;
            this.generateProgress = { processed: 0, total: 0 };
            if (this.confirmDialog && this.confirmDialog._resolve) {
                this.confirmDialog._resolve(false);
            }
            this.confirmDialog = {
                show: false,
                title: 'Confirmação',
                text: '',
                confirmLabel: 'Confirmar',
                cancelLabel: 'Cancelar',
                _resolve: null,
            };
            this.snackbar.show = false;
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = null;
            }
        },

        openConfirm(text, opts = {}) {
            const title = opts.title || 'Confirmação';
            const confirmLabel = opts.confirmLabel || 'Confirmar';
            const cancelLabel = opts.cancelLabel || 'Cancelar';

            // Fecha/resolve confirmacao anterior, se houver
            if (this.confirmDialog && this.confirmDialog._resolve) {
                this.confirmDialog._resolve(false);
            }

            this.confirmDialog.title = title;
            this.confirmDialog.text = text;
            this.confirmDialog.confirmLabel = confirmLabel;
            this.confirmDialog.cancelLabel = cancelLabel;
            this.confirmDialog.show = true;

            return new Promise((resolve) => {
                this.confirmDialog._resolve = resolve;
            });
        },

        resolveConfirm(val) {
            if (this.confirmDialog && this.confirmDialog._resolve) {
                this.confirmDialog._resolve(val);
            }
            this.confirmDialog.show = false;
            this.confirmDialog._resolve = null;
        },

        notify(message, color = 'error') {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },

        resetAndReload() {
            this.page = 1;
            this.selected = [];
            this.selectedCurrent = [];
            this.excludedSelected = [];
            this.selectAllFiltered = false;
            this.filteredTotal = 0;
            this.cancelGenerate = true;
            this.generateProgress = { processed: 0, total: 0 };
            this.getItems();
        },

        onSearchInput() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                this.resetAndReload();
            }, 400);
        },

        buildTeacherPayload({ page, perPage, columns } = {}) {
            const payload = {
                column_order: 'name',
                direction: 'asc',
                page: page || this.page,
                per_page: perPage || this.maxSelected,
                search: this.search || '',
                find_columns: {
                    active: 1,
                    teacher_status_id: 1,
                },
            };

            if (columns) {
                payload.columns = columns;
            }

            // Construir filter_relations com todos os critérios de segmentação
            const filterRelations = [];

            const toIds = (val) => {
                if (!val) return [];
                const arr = Array.isArray(val) ? val : [val];
                return arr
                    .map(v => (typeof v === 'object' && v != null && v.id != null) ? v.id : v)
                    .filter(v => v != null && v !== '');
            };

            const companyIdsStr = toIds(this.companyIds).join(',');
            const campusIdsStr = toIds(this.campusIds).join(',');
            const courseIdsStr = toIds(this.courseIds).join(',');
            const teacherPositionIdsStr = toIds(this.teacherPositionIds).join(',');

            // Filtros baseados no vínculo (contrato) do professor
            const contractInnerRelations = [];
            const contractDirectFilters = [];

            if (companyIdsStr) {
                contractDirectFilters.push({
                    key: 'teacher_contracts.company_id',
                    value: companyIdsStr,
                    clause: 'whereIn',
                });
            }

            if (campusIdsStr) {
                contractInnerRelations.push({
                    name: 'campuses',
                    key: 'campuses.id',
                    value: campusIdsStr,
                    clause: 'whereIn',
                });
            }

            if (this.educationalGroupId) {
                contractInnerRelations.push({
                    name: 'campuses',
                    key: 'campuses.educational_group_id',
                    value: this.educationalGroupId,
                    clause: 'where',
                });
            }

            if (courseIdsStr) {
                contractInnerRelations.push({
                    name: 'courses',
                    key: 'courses.id',
                    value: courseIdsStr,
                    clause: 'whereIn',
                });
            }

            if (teacherPositionIdsStr) {
                contractDirectFilters.push({
                    key: 'teacher_contracts.teacher_position_id',
                    value: teacherPositionIdsStr,
                    clause: 'whereIn',
                });
            }

            // Monta filtros de contrato: campos diretos como filter_relations separados,
            // innerRelations agrupados em um único objeto
            contractDirectFilters.forEach(f => {
                filterRelations.push({
                    name: 'contracts',
                    key: f.key,
                    value: f.value,
                    clause: f.clause,
                });
            });

            if (contractInnerRelations.length) {
                filterRelations.push({
                    name: 'contracts',
                    innerRelations: contractInnerRelations,
                });
            }

            if (this.workLoadVariationStatus) {
                filterRelations.push({
                    name: 'indicators',
                    key: 'work_load_variation_status_id',
                    value: this.workLoadVariationStatus,
                });
            }

            if (filterRelations.length) {
                payload.filter_relations = filterRelations;
            }

            return payload;
        },
        
        async getItems(loadingRefresh = false) {

            this.loadingRefresh = loadingRefresh;
            this.loading = true;
            this.loadingSaving = false;
            this.selectedCurrent = [];

            const payload = this.buildTeacherPayload({ page: this.page, perPage: this.maxSelected });

            try {
                const res = await this.ActionFindTeachers(payload);
                this.totalPages = res.meta.last_page;
                this.filteredTotal = res.meta.total || 0;
                this.items = res.data || [];

                if (this.selectAllFiltered) {
                    this.selectedCurrent = this.items
                        .map(i => i.id)
                        .filter(id => !this.excludedSelected.includes(id));
                } else {
                    this.items.forEach(item => {
                        if (this.selected.includes(item.id)) {
                            this.selectedCurrent.push(item.id);
                        }
                    });
                }
            } catch (err) {
                this.items = [];
                this.totalPages = 0;
                this.filteredTotal = 0;
                if (process.env.NODE_ENV !== 'production') {
                    console.error('[SysTermGenerate] Erro ao carregar docentes:', err);
                }
            } finally {
                this.loading = false;
                this.loadingRefresh = false;
            }
        },

        pagination(){

            this.getItems();

        },


        async generate(){

            if(!this.term_id){
                return;
            }

            // Confirmacao para grandes volumes
            if (this.selectAllFiltered && this.effectiveSelectedCount > 500) {
                const ok = await this.openConfirm(this.confirmText.generateAll(this.effectiveSelectedCount), {
                    title: 'Gerar termos',
                    confirmLabel: 'Gerar',
                });
                if (!ok) return;
            }

            this.cancelGenerate = false;
            this.generateProgress = { processed: 0, total: this.selectAllFiltered ? this.effectiveSelectedCount : this.selected.length };
            this.loadingSaving = true;

            const chunk = (arr, size) => {
                const out = [];
                for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
                return out;
            };

            try {
                if (this.selectAllFiltered) {
                    // Buscar IDs paginados e gerar em lotes
                    const firstPayload = this.buildTeacherPayload({ page: 1, perPage: this.batchSize, columns: 'id' });
                    const firstRes = await this.ActionFindTeachers(firstPayload);
                    const lastPage = firstRes.meta.last_page || 1;
                    this.filteredTotal = firstRes.meta.total || this.filteredTotal;
                    this.generateProgress.total = this.effectiveSelectedCount;

                    const handlePage = async (res) => {
                        const ids = (res.data || [])
                            .map(t => t && t.id)
                            .filter(id => Boolean(id) && !this.excludedSelected.includes(id));
                        if (!ids.length) return;
                        await this.ActionUpdateTermSignatureGenerate({ teacher_ids: ids, term_id: this.term_id });
                        this.generateProgress.processed += ids.length;
                    };

                    await handlePage(firstRes);

                    for (let p = 2; p <= lastPage; p++) {
                        if (this.cancelGenerate) break;
                        const payload = this.buildTeacherPayload({ page: p, perPage: this.batchSize, columns: 'id' });
                        const res = await this.ActionFindTeachers(payload);
                        await handlePage(res);
                    }
                } else {
                    const batches = chunk(this.selected, this.batchSize);
                    for (let i = 0; i < batches.length; i++) {
                        if (this.cancelGenerate) break;
                        const ids = batches[i];
                        await this.ActionUpdateTermSignatureGenerate({ teacher_ids: ids, term_id: this.term_id });
                        this.generateProgress.processed += ids.length;
                    }
                }

                if (!this.cancelGenerate) {
                    this.$emit('onCompleted');
                }
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    console.error('[SysTermGenerate] Erro ao gerar termos:', err);
                }
                const msg = err?.message || err?.errors || 'Erro ao gerar termos.';
                this.notify(typeof msg === 'string' ? msg : 'Erro ao gerar termos.');
            } finally {
                this.loadingSaving = false;
            }
       },

        toggle () {

            // Agora significa: selecionar TODOS do filtro
            this.$nextTick(async () => {
                if (this.selectAllFiltered) {
                    this.selectAllFiltered = false;
                    this.selected = [];
                    this.selectedCurrent = [];
                    this.excludedSelected = [];
                    this.filteredTotal = 0;
                    return;
                }

                // Garantir que temos o total do filtro
                if (!this.filteredTotal) {
                    try {
                        const res = await this.ActionFindTeachers(this.buildTeacherPayload({ page: 1, perPage: 1, columns: 'id' }));
                        this.filteredTotal = res.meta.total || 0;
                    } catch (e) {
                        this.filteredTotal = 0;
                    }
                }

                const ok = await this.openConfirm(this.confirmText.selectAll(this.filteredTotal), {
                    title: 'Selecionar todos',
                    confirmLabel: 'Selecionar',
                });
                if (!ok) return;

                this.selectAllFiltered = true;
                this.selected = [];
                this.excludedSelected = [];
                this.selectedCurrent = this.items.map(i => i.id);
                this.page = 1;
                this.getItems();
            })
        },

        clearFilter(){
            this.selected = [];
            this.selectedCurrent = [];
            this.excludedSelected = [];
            this.selectAllFiltered = false;
            this.filteredTotal = 0;
            this.generateProgress = { processed: 0, total: 0 };
        },

        isCheckedTeacher(index){
            let id = this.items[index]['id'];

            if (this.selectAllFiltered) return !this.excludedSelected.includes(id);
            
            return this.selected.includes(id);
        },

        selectTeacher(index){
            let id = this.items[index]['id'];

            if (this.selectAllFiltered) {
                if (this.excludedSelected.includes(id)) {
                    this.excludedSelected.splice(this.excludedSelected.indexOf(id), 1);
                } else {
                    this.excludedSelected.push(id);
                }

                if (this.selectedCurrent.includes(id)) {
                    this.selectedCurrent.splice(this.selectedCurrent.indexOf(id), 1);
                } else {
                    this.selectedCurrent.push(id);
                }

                return;
            }
            
            if(this.selected.includes(id)){
                this.selected.splice(this.selected.indexOf(id), 1);
            }else{
                this.selected.push(id);
            }

            if(this.selectedCurrent.includes(id)){
                this.selectedCurrent.splice(this.selectedCurrent.indexOf(id), 1);
            }else{
                this.selectedCurrent.push(id);
            }
            
        },

        

    }
}
</script>
